import React from 'react';
import { authRoles } from '../../store/auth';

const AboutUsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: true,
        },
        footer: {
          display: true,
        },
      },
    },
  },
  auth: authRoles.user,
  routes: [
    {
      path: '/AboutUs',
      component: React.lazy(() => import('./AboutUs')),
    },
  ],
};

export default AboutUsConfig;
